export default __webpack_public_path__ + "static/media/cerebrisans-regular.ccb7af1c.eot";